<template>
	<div class="container">
		<div class="thead">
			<div class="ttitle">
				<div>seo中介平台让您的网站优化有保障</div></br>
				<p>-每天为您监控所优化的网站关键词-</p>
			</div>
			<div class="thead-box">
				<div class="t-title">
					<span>我要优化</span>
					<div class="line">
						<!-- 小横线 -->
					</div>
				</div>
			</div>
			<!--  -->
			<el-form class="formOne form" ref="form" :rules="rules"  :model="form" label-width="100px" >
				<p class="zy">注意：发布前请先添加企业微信：<span>19930400414</span>,以便审核资料的真实性！</p>
				<div class="boxBox">
					<div class="left">
						<el-form-item label="pc端">
							<el-checkbox-group v-model="form.pc">
								 <el-checkbox  type="hidden" v-for="(item,index) in list"  :key="item.id" :label="item.value"  :value="item.id">
									 
								</el-checkbox>
							</el-checkbox-group>
							<input type="hidden" name="pc[]" id="" v-model="form.pc"  value="" />
						</el-form-item>
						<el-form-item label="网址" prop="url" class="url">
							<el-input v-model="form.url" placeholder="请输入你要优化的网址"></el-input>
						</el-form-item>
						<el-form-item label="关键词" prop="key" class="key">
							<el-input type="textarea" v-model="form.key" placeholder="请输入你要优化的关键词，多个关键词请用逗号隔开，最多支持20个">
							</el-input>
						</el-form-item>
						<div class="ts">
							<div class="left"> 多个关键词请用逗号隔开 </div>
						</div>
						<div class="bot">
							<el-checkbox v-model="checked" checked="checked">
								<span class="bot_zs">同意并遵守</span>
								<a class="blue" target="_blank"
									:href="$store.state.HIMG_URL+'xiaodu.pdf'">《中链企通支付服务协议》</a>
							</el-checkbox>

						</div>
						<div class="btn">
							<div class="tj">
								<input type="button" name="" value="开始发布" @click="getform" />
							</div>
							<div class="rs">
								<input type="reset" name="" placeholder="重新填写" />
							</div>
						</div>
					</div>
					<div class="right">
						<el-form-item label="移动端">
							<el-checkbox-group v-model="form.mobile">
								 <el-checkbox  type="hidden" v-for="(item,index) in list2"  :key="item.id" :label="item.value"  :value="item.id">
									 
								</el-checkbox>
							</el-checkbox-group>
							<input type="hidden" name="mobile[]" id="" v-model="form.mobile"  value="" />
						</el-form-item>
						<div class="hyBox">
							<el-form-item label="排名要求" prop="pm">
								<el-select v-model="form.pm" placeholder="请选择">
									<el-option v-for="item in paiming" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="所属行业" prop="catid1">
								<el-cascader :options="options" :props="props" v-model="form.catid1"
									@change="catidChange" />
							</el-form-item>
						</div>
						<el-form-item label="排名地区">
							<area-select :data="pca" type="text" v-model="selected2" @change="getSite2">
							</area-select>
						</el-form-item>
						<div class="lxfs">
							<el-form-item label="联系人" prop="username">
								<el-input v-model="form.username" placeholder="请输入联系人姓名"></el-input>
							</el-form-item>
							<el-form-item label="手机" prop="phone">
								<el-input v-model="form.phone" placeholder="请输入常用手机号"></el-input>
							</el-form-item>
						</div>
						<div class="haoma">
							<el-form-item label="QQ" prop="qq">
								<el-input v-model="form.qq" placeholder="请输入QQ号"></el-input>
							</el-form-item>
							<el-form-item label="微信" prop="wx">
								<el-input v-model="form.wx" placeholder="请输入微信号"></el-input>
							</el-form-item>
						</div>
						<div class="zhu">
							<p>
								注:联系资料必须真实，SEO中介平台会进行核实，核实通过后，该订单才会生效
							</p>
						</div>
					</div>
				</div>
			</el-form>
			
		</div>
		<div class="bz">
			<div class="bz-box">
				<div class="box-title">
					流程步骤
				</div>
				<div class="b-box">
					<!-- 01 -->
					<div class="box box1">
						<div class="b1-pic"></div>
						<div class="b1-box">
							<div class="x1-pic"></div>
						</div>
		
						<span>客户提出要求</span>
					</div>
					<!-- 箭头 -->
					<div class="box arrows">
						<div class="arrows-pic"></div>
					</div>
					<!-- 02 -->
					<div class="box box2">
						<div class="b2-pic"></div>
						<div class="x2-pic"></div>
						<span>优化师提供报价</span>
					</div>
					<!-- 箭头 -->
					<div class="box arrows">
						<div class="arrows-pic"></div>
					</div>
					<!-- 03 -->
					<div class="box box3">
						<div class="b3-pic"></div>
						<div class="x3-pic"></div>
						<span>双方确认合作</span>
					</div>
					<!-- 箭头 -->
					<div class="box arrows">
						<div class="arrows-pic"></div>
					</div>
					<!-- 04 -->
					<div class="box box4">
						<div class="b4-pic"></div>
						<div class="x4-pic"></div>
						<span>客户付款到平台</span>
					</div>
					<!-- 箭头 -->
					<div class="box arrows">
						<div class="arrows-pic"></div>
					</div>
					<!-- 05 -->
					<div class="box box5">
						<div class="b5-pic"></div>
						<div class="x5-pic"></div>
						<span>优化师开始优化</span>
					</div>
					<!-- 竖向箭头 -->
					<div class="box arr">
						<div class=" arrows2">
							<div class="arrows-pic2"></div>
						</div>
					</div>
					<!-- 10 -->
					<div class="box box10">
						<div class="b10-pic"></div>
						<div class="x10-pic"></div>
						<span>完成</span>
					</div>
					<!-- jian -->
					<div class="box arrows">
						<div class="arrows-pic"></div>
					</div>
					<!-- 9 -->
					<div class="box box9">
						<div class="b9-pic"></div>
						<div class="x9-pic"></div>
						<span>未达标词退还给客户</span>
					</div>
					<!-- jiantou -->
					<div class="box arrows">
						<div class="arrows-pic"></div>
					</div>
					<!-- 8 -->
					<div class="box box8">
						<div class="b8-pic"></div>
						<div class="x8-pic"></div>
						<span>达标词结算给优化师</span>
					</div>
					<!--箭头 -->
					<div class="box arrows">
						<div class="arrows-pic"></div>
					</div>
					<!-- 07 -->
					<div class="box box7">
						<div class="b7-pic"></div>
						<div class="x7-pic"></div>
						<span>站长工具监控</span>
					</div>
					<!-- 箭头 -->
					<div class="box arrows">
						<div class="arrows-pic"></div>
					</div>
					<!-- 6 -->
					<div class="box box6">
						<div class="b6-pic"></div>
						<div class="x6-pic"></div>
						<span>优化师完成优化</span>
					</div>
		
		
				</div>
			</div>
		</div>
		<div class="seo">
			<div class="seo-box">
				<div class="seo-head">
					<div>为什么要用SEO中介平台？</div></br>
					<p>-资源+需求的精准匹配</p>
				</div>
				<div class="seo-cont">
					<div class="s-left">
						<div class="left-top">
							<div class="hz-img"></div>
							<div class="hz-text">
								<b>汇集众多优秀SEO优化师</b>
								<div class="hz-text">
									联合多家SEO服务商汇聚众多SEO从业者为</br>
									你提供提供详细的网站诊断、优化推广等其</br>
									它专业咨询服务
								</div>
							</div>
						</div>
						<div class="left-bottom">
							<div class="hz-img"></div>
							<div class="hz-text">
								<b>站长工具关键词排名监控保障效果</b>
								<div class="hz-text">
									站长工具为客户提供关键词多个节点监控服务、</br>
									保障排名效果</br>
								</div>
							</div>
						</div>
					</div>
					<div class="s-center">
						<div class="c-img"></div>
					</div>
					<div class="s-right">
						<div class="right-top">
							<div class="hz-img"></div>
							<div class="hz-text">
								<b>汇集众多优秀SEO优化师</b>
								<div class="hz-text">
									联合多家SEO服务商汇聚众多SEO从业者为</br>
									你提供提供详细的网站诊断、优化推广等其</br>
									它专业咨询服务
								</div>
							</div>
						</div>
						<div class="right-bottom">
							<div class="hz-img"></div>
							<div class="hz-text">
								<b>站长工具关键词排名监控保障效果</b>
								<div class="hz-text">
									站长工具为客户提供关键词多个节点监控服务、</br>
									保障排名效果</br>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="bot">
			<div class="bot-box">
				<div class="box-title">
					<div>SEO中介平台=优化师+客户需求+双方保障</div></br>
					<p>-优化师有单可做，客户省钱有保障-</p>
				</div>
				<div class="box-b">
					<div class="box-left">
						<img src="../assets/img/seo-l.png">
					</div>
					<div class="box-right">
						<img src="../assets/img/seo-r.png">
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
	import {
		pca,
		pcaa
	} from 'area-data'
	import 'vue-area-linkage/dist/index.css'
	export default {
		data() {
			return {
				list:[{
					id:'bd',
					value:'百度'
				},{
					id:'sll',
					value:'360'
				},{
					id:'sg',
					value:'搜狗'
				}],
				list2:[{
					id:'bd',
					value:'百度'
				},{
					id:'sll',
					value:'360'
				},{
					id:'sg',
					value:'搜狗'
				},{
					id:'sm',
					value:'神马'
				}],
				paiming: [{
					value: '前10名',
					label: '前10名'
				}, {
					value: '前15名',
					label: '前15名'
				}, {
					value: '前20名',
					label: '前20名'
				}],
				form: {
					catid1: '',
					pm: '',
					url: '',
					sheng: '',
					shi: '',
					qq: '',
					wx: '',
					username: '',
					phone: '',
					mobile: [],
					pc: [],
				},
				pca,
				pcaa,
				props: {
					label: 'catname',
					value: 'id'
				},
				options: [],
				selected2: [],
				rules: {
					catid1: {
						required: true,
						message: '请选择分类',
						trigger: ['blur', 'change']
					},
					pm: {
						required: true,
						message: '请选择排名',
						trigger: ['blur', 'change']
					},
					url: {
						required: true,
						message: '请输入你要优化的网址',
						trigger: ['blur', 'change']
					},
					key: {
						required: true,
						message: '请输入关键词',
						trigger: ['blur', 'change']
					},
					qq: {
						required: true,
						message: '请输入常用qq号码',
						trigger: ['blur', 'change']
					},
					wx: {
						required: true,
						message: '请输入常用微信号',
						trigger: ['blur', 'change']
					},
					username: {
						required: true,
						message: '请输入联系人姓名',
						trigger: ['blur', 'change']
					},
					phone: {
						required: true,
						message: '请输入常用手机号',
						trigger: ['blur', 'change']
					},

				},
			}
		},
		created() {
			this.$axios.get('Myseller-Setting-gethangye?user_id=' + this.$store.state.USER_ID).then(data => {
				this.options = data
			})
		},
		methods: {
			catidChange(data) {
				this.form.catid1 = data[data.length - 1]
			},
			getSite2(data) {
				this.form.sheng = data[0]
				this.form.shi = data[1]
			},
			getform() {
				this.$refs.form.validate(valid => {
					if (valid) {
						this.$axios.post('Myseller-setting-applyService', this.form).then(res => {
							if(res.code == 200){
								this.$alert('申请成功，我们的客户经理将于1个工作日内与您联系！', 'seo优化', {
									type: 'success'
								})
							}
						})
					}
				})

			}
		},
		watch: {
			purForm(val) {
				this.form = val
				this.form.catss = Number(val.catss)
				this.form.home_type = Number(val.home_type)
				this.selected1.push(this.form.xiangmu_di)
				this.selected2.push(this.form.sheng, this.form.shi)
			}
		},
		props: ['purForm']
	}
</script>
<style scoped="scoped">
	.form>>>.area-select {
		height: 40px;
		line-height: 26px;
		margin-left: 0;
		margin-bottom: 10px;
	}
	.container {}

	.thead {
		height: 882px;
		background: url(../assets/img/headbj.png) bottom center no-repeat;
	}

	.thead .ttitle {
		height: 150px;
	}

	.thead .ttitle div {
		height: 100px;
		line-height: 100px;
		text-align: center;
		font-size: 34px;
		color: #fff;
	}

	.thead .ttitle p {
		line-height: 30px;
		line-height: 30px;
		font-size: 18px;
		text-align: center;
		color: #fff;
	}

	.thead .thead-box {
		width: 1200px;
		overflow: hidden;
		background-color: #fff;
		margin: 0 auto;
	}

	.thead .thead-box input:focus,
	.thead .thead-box textarea:focus {
		outline: none;
	}

	.thead .thead-box .t-title {
		padding-top: 30px;
		height: 74px;
		font-size: 24px;
		color: #006eff;
		text-align: center;
	}

	/* 小横线 */
	.thead .thead-box .t-title .line {
		width: 87px;
		height: 7px;
		margin: 5px auto;
		background-color: #006EFF;
		border-radius: 10px;
	}

	.boxBox {
		width: 1200px;
		margin: 0 auto;
		display: flex;
		justify-content: space-around;
	}
	.el-checkbox-group{
		display: flex;
		justify-content: space-around;
	}
	.el-checkbox-group .bdiv .el-checkbox__inner{
		display: none !important;
		z-index: -200;
	}
	.el-checkbox__inner{
		display: '' !important;
		z-index: -200;
	}
	/* .el-checkbox-group label:nth-child(1)  .bdiv{
		width: 86px;
		height: 36px;
		border: 1px solid #ccc;
		background: url(../assets/img/bd.png) center center no-repeat;
		position: absolute;
		left: 0;right: 0;
		bottom: 0;top: 0;
	} */

	/* .bdiv:nth-child(1) el-checkbox {
		position: absolute;
		width: 100%;
		height: 100%;
		left: 0;
		top: 0;
		opacity: 0;
	} */

	/* .bdiv:nth-child(1)  el-checkbox:checked+i {
		display: block;
	} */

	
	.el-checkbox__label{
		margin-left: -14px !important;
	}
	/* .el-checkbox-group label:nth-child(2)  .bdiv{
		width: 86px;
		height: 36px;
		border: 1px solid #ccc;
		background: url(../assets/img/360.png) center center no-repeat;
		position: absolute;
		left: 0;right: 0;
		bottom: 0;top: 0;

	} */

	/* .bdiv:nth-child(2) input {
		position: absolute;
		width: 100%;
		height: 100%;
		left: 0;
		top: 0;
		opacity: 0;
	} */

	/* .bdiv:nth-child(2) input:checked+i {
		display: block;
	} */

	/* .bdiv:nth-child(2) i {
		position: absolute;
		width: 100%;
		height: 100%;
		border: 1px solid red;
		left: 0;
		top: 0;
		display: none;
		background: url(../assets/img/xz.png) right bottom no-repeat;
	} */

	/* .el-checkbox-group label:nth-child(3) .bdiv {
		width: 86px;
		height: 36px;
		border: 1px solid #ccc;
		background: url(../assets/img/sg.png) center center no-repeat;
		position: absolute;
		left: 0;right: 0;
		bottom: 0;top: 0;

	} */

	/* .bdiv:nth-child(3) input {
		position: absolute;
		width: 100%;
		height: 100%;
		left: 0;
		top: 0;
		opacity: 0;
	} */

	/* .bdiv:nth-child(3) input:checked+i {
		display: block;
	} */

	/* .bdiv:nth-child(3) i {
		position: absolute;
		width: 100%;
		height: 100%;
		border: 1px solid red;
		left: 0;
		top: 0;
		display: none;
		background: url(../assets/img/xz.png) right bottom no-repeat;
	}
 */
	.key {
		margin: 10px 0;
	}

	.el-input__inner {
		width: 380px !important;
	}
	.el-textarea {
		width: 320px !important;
	}

	.ts {
		color: #a1a1a1;
	}

	.ts .left {
		margin-left: 95px;
		padding-top: 14px;
	}

	.bot_zs {
		color: #666;
	}

	.bot {
		margin: 30px 42px;
	}

	.btn {
		display: flex;
		justify-content: space-around;
	}

	.tj input {
		width: 233px;
		height: 49px;
		line-height: 49px;
		font-size: 18px;
		color: #fff;
		outline: none;
		border: 1px solid transparent;
		background-color: #ff7000;
	}

	.rs input {
		width: 130px;
		height: 49px;
		line-height: 49px;
		font-size: 18px;
		color: #666;
		outline: none;
		border: 1px solid transparent;
		background-color: #eeeeee;
	}

	.formOne {
		width: 1200px;
		margin: 0 auto;
		overflow: hidden;
		background-color: #fff;
	}

	.zy {
		font-size: 14px;
		padding: 10px 0 10px 49px;
	}

	.zy span {
		color: red;
	}

	.labelBox {
		display: flex;
		justify-content: space-around;
		align-items: center;
	}

	.hyBox,
	.lxfs,
	.haoma {
		display: flex;
		justify-content: space-between;
	}

	.zhu {
		height: 54px;
		line-height: 54px;
		color: #ff7000;
		font-size: 14px;
		margin-left: 10px;
	}

	.bdss {
		display: inline-block;
		width: 86px;
		height: 36px;
		border: 1px solid #ccc;
		background: url(../assets/img/bdss.png) center center no-repeat;
		position: relative;

	}

	.bdss input {
		position: absolute;
		width: 100%;
		height: 100%;
		left: 0;
		top: 0;
		opacity: 0;
	}

	.bdss input:checked+i {
		display: block;
	}

	.bdss i {
		position: absolute;
		width: 100%;
		height: 100%;
		border: 1px solid red;
		left: 0;
		top: 0;
		display: none;
		background: url(../assets/img/xz.png) right bottom no-repeat;
	}

	.sllss {
		display: inline-block;
		width: 86px;
		height: 36px;
		border: 1px solid #ccc;
		background: url(../assets/img/360ss.png) center center no-repeat;
		position: relative;

	}

	.sllss input {
		position: absolute;
		width: 100%;
		height: 100%;
		left: 0;
		top: 0;
		opacity: 0;
	}

	.sllss input:checked+i {
		display: block;
	}

	.sllss i {
		position: absolute;
		width: 100%;
		height: 100%;
		border: 1px solid red;
		left: 0;
		top: 0;
		display: none;
		background: url(../assets/img/xz.png) right bottom no-repeat;
	}

	.sgss {
		display: inline-block;
		width: 86px;
		height: 36px;
		border: 1px solid #ccc;
		background: url(../assets/img/sgss.png) center center no-repeat;
		position: relative;

	}

	.sgss input {
		position: absolute;
		width: 100%;
		height: 100%;
		left: 0;
		top: 0;
		opacity: 0;
	}

	.sgss input:checked+i {
		display: block;
	}

	.sgss i {
		position: absolute;
		width: 100%;
		height: 100%;
		border: 1px solid red;
		left: 0;
		top: 0;
		display: none;
		background: url(../assets/img/xz.png) right bottom no-repeat;
	}

	.smss {
		display: inline-block;
		width: 86px;
		height: 36px;
		border: 1px solid #ccc;
		background: url(../assets/img/smss.png) center center no-repeat;
		position: relative;

	}

	.smss input {
		position: absolute;
		width: 100%;
		height: 100%;
		left: 0;
		top: 0;
		opacity: 0;
	}

	.smss input:checked+i {
		display: block;
	}

	.smss i {
		position: absolute;
		width: 100%;
		height: 100%;
		border: 1px solid red;
		left: 0;
		top: 0;
		display: none;
		background: url(../assets/img/xz.png) right bottom no-repeat;
	}

	
	/*  */
	/* 第二部分 */
	.bz {
		width: 100%;
		overflow: hidden;
		font-size: 14px;
		padding-bottom: 80px;
		background-color: #fff;
	}
	
	.bz .bz-box {
		width: 1200px;
		margin: 0 auto;
	}
	
	.bz .bz-box .box-title {
		height: 130px;
		line-height: 90px;
		text-align: center;
		font-size: 32px;
	}
	
	/* dahezi */
	.bz .bz-box .b-box {
		text-align: center;
		margin: 0 auto;
	}
	
	.bz .bz-box .b-box .box {
		width: 13%;
		float: left;
	}
	
	/* 图片 */
	.bz .bz-box .b-box .box .b1-pic {
		width: 153px;
		height: 94px;
	
		background: url(../assets/img/xuebibj.png) -73px -527px;
	}
	
	/* 小图 盒子*/
	.bz .bz-box .b-box .box .b1-box {
		width: 153px;
		height: 27px;
	}
	
	/* 小图 */
	.bz .bz-box .b-box .box .x1-pic {
		width: 22px;
		height: 25px;
		margin: 0 auto;
		background: url(../assets/img/xuebibj.png) -199px -382px;
	}
	
	/* 向右箭头盒子 */
	.bz .bz-box .b-box .arrows {
		width: 100px;
		height: 94px;
	}
	
	/* 箭头 */
	.bz .bz-box .b-box .arrows .arrows-pic {
		width: 94px;
		height: 94px;
		background: url(../assets/img/xuebibj.png) -297px -154px;
	}
	
	/*  */
	/* 图片 */
	.bz .bz-box .b-box .box .b2-pic {
		width: 153px;
		height: 94px;
	
		background: url(../assets/img/xuebibj.png) -264px -527px;
	}
	
	/* 小图 盒子*/
	.bz .bz-box .b-box .box .b2-box {
		width: 153px;
		height: 27px;
		margin: 0 auto;
	
	}
	
	/* 小图 */
	.bz .bz-box .b-box .box .x2-pic {
		width: 22px;
		height: 25px;
		margin: 0 auto;
		background: url(../assets/img/xuebibj.png) -300px -382px;
	}
	
	/* 03 */
	/* 图片 */
	.bz .bz-box .b-box .box .b3-pic {
		width: 153px;
		height: 94px;
		background: url(../assets/img/xuebibj.png) -467px -527px;
	}
	
	/* 小图 盒子*/
	.bz .bz-box .b-box .box .b3-box {
		width: 153px;
		height: 27px;
		margin: 0 auto;
	
	}
	
	/* 小图 */
	.bz .bz-box .b-box .box .x3-pic {
		width: 22px;
		height: 25px;
		margin: 0 auto;
		background: url(../assets/img/xuebibj.png) -404px -382px;
	}
	
	/* 04 */
	/* 图片 */
	.bz .bz-box .b-box .box .b4-pic {
		width: 153px;
		height: 94px;
	
		background: url(../assets/img/xuebibj.png) -669px -527px;
	}
	
	/* 小图 盒子*/
	.bz .bz-box .b-box .box .b4-box {
		width: 153px;
		height: 27px;
		margin: 0 auto;
	
	}
	
	/* 小图 */
	.bz .bz-box .b-box .box .x4-pic {
		width: 22px;
		height: 25px;
		margin: 0 auto;
		background: url(../assets/img/xuebibj.png) -508px -382px;
	}
	
	/* 05 */
	/* 图片 */
	.bz .bz-box .b-box .box .b5-pic {
		width: 153px;
		height: 94px;
	
		background: url(../assets/img/xuebibj.png) -868px -527px;
	}
	
	/* 小图 盒子*/
	.bz .bz-box .b-box .box .b5-box {
		width: 153px;
		height: 27px;
		margin: 0 auto;
	
	}
	
	/* 小图 */
	.bz .bz-box .b-box .box .x5-pic {
		width: 22px;
		height: 25px;
		margin: 0 auto;
		background: url(../assets/img/xuebibj.png) -602px -382px;
	}
	
	/* 向右箭头盒子 */
	.bz .bz-box .b-box .arr {
		width: 1200px;
		margin: 0 auto;
	}
	
	.bz .bz-box .b-box .arr .arrows2 {
		width: 144px;
		height: 94px;
		float: right;
	}
	
	/* 竖向箭头 */
	.bz .bz-box .b-box .arr .arrows2 .arrows-pic2 {
		width: 94px;
		height: 94px;
		background: url(../assets/img/xuebibj.png) -196px -163px;
	}
	
	/* 10 */
	/* 图片 */
	.bz .bz-box .b-box .box .b10-pic {
		width: 153px;
		height: 94px;
	
		background: url(../assets/img/xuebibj.png) -73px -723px;
	}
	
	/* 小图 盒子*/
	.bz .bz-box .b-box .box .b10-box {
		width: 153px;
		height: 27px;
		margin: 0 auto;
	
	}
	
	/* 小图 */
	.bz .bz-box .b-box .box .x10-pic {
		width: 22px;
		height: 25px;
		margin: 0 auto;
		background: url(../assets/img/xuebibj.png) -199px -287px;
	}
	
	/* 9 */
	/* 图片 */
	.bz .bz-box .b-box .box .b9-pic {
		width: 153px;
		height: 94px;
	
		background: url(../assets/img/xuebibj.png) -265px -723px;
	}
	
	/* 小图 盒子*/
	.bz .bz-box .b-box .box .b9-box {
		width: 153px;
		height: 27px;
		margin: 0 auto;
	
	}
	
	/* 小图 */
	.bz .bz-box .b-box .box .x9-pic {
		width: 22px;
		height: 25px;
		margin: 0 auto;
		background: url(../assets/img/xuebibj.png) -304px -287px;
	}
	
	/* 8*/
	/* 图片 */
	.bz .bz-box .b-box .box .b8-pic {
		width: 153px;
		height: 94px;
	
		background: url(../assets/img/xuebibj.png) -466px -723px;
	}
	
	/* 小图 盒子*/
	.bz .bz-box .b-box .box .b8-box {
		width: 153px;
		height: 27px;
		margin: 0 auto;
	
	}
	
	/* 小图 */
	.bz .bz-box .b-box .box .x8-pic {
		width: 22px;
		height: 25px;
		margin: 0 auto;
		background: url(../assets/img/xuebibj.png) -407px -287px;
	}
	
	/* 7*/
	/* 图片 */
	.bz .bz-box .b-box .box .b7-pic {
		width: 153px;
		height: 94px;
	
		background: url(../assets/img/xuebibj.png) -666px -723px;
	}
	
	/* 小图 盒子*/
	.bz .bz-box .b-box .box .b7-box {
		width: 153px;
		height: 27px;
		margin: 0 auto;
	
	}
	
	/* 小图 */
	.bz .bz-box .b-box .box .x7-pic {
		width: 22px;
		height: 25px;
		margin: 0 auto;
		background: url(../assets/img/xuebibj.png) -500px -287px;
	}
	
	/* 6*/
	/* 图片 */
	.bz .bz-box .b-box .box .b6-pic {
		width: 153px;
		height: 94px;
	
		background: url(../assets/img/xuebibj.png) -866px -723px;
	}
	
	/* 小图 盒子*/
	.bz .bz-box .b-box .box .b6-box {
		width: 153px;
		height: 27px;
		margin: 0 auto;
	
	}
	
	/* 小图 */
	.bz .bz-box .b-box .box .x6-pic {
		width: 22px;
		height: 25px;
		margin: 0 auto;
		background: url(../assets/img/xuebibj.png) -600px -287px;
	}
	
	.seo {
		background-color: #f0f7fd;
		width: 100%;
		font-size: 16px;
		overflow: hidden;
		padding-bottom: 100px;
	}
	
	.seo .seo-box {
		width: 1200px;
		margin: 0 auto;
	}
	
	.seo .seo-box .seo-head {
		padding: 30px 0 10px 0;
		height: 120px;
		text-align: center;
	}
	
	.seo .seo-box .seo-head div {
		font-size: 32px;
		color: #333;
	}
	
	.seo .seo-box .seo-head p {
		font-size: 20px;
		color: #0c84fe;
	}
	
	/* dahezi  */
	.seo .seo-box .seo-cont {}
	
	/* 左边的 */
	.seo .seo-box .seo-cont .s-left {
		width: 33%;
		height: 400px;
		float: left;
	}
	
	.seo .seo-box .seo-cont .s-left .left-top {
		overflow: hidden;
		padding-bottom: 106px;
	}
	
	.seo .seo-box .seo-cont .s-left .left-top .hz-img {
		width: 110px;
		height: 110px;
		float: left;
		background: url(../assets/img/xuebibj.png) -99px -927px;
	}
	
	.seo .seo-box .seo-cont .s-left .left-top .hz-text {
		width: 280px;
		float: left;
		color: #606266;
		margin-top: 10px;
		padding-top: 10px;
	}
	
	/* dixia */
	.seo .seo-box .seo-cont .s-left .left-bottom .hz-img {
		width: 110px;
		height: 110px;
		float: left;
		background: url(../assets/img/xuebibj.png) -497px -927px;
	}
	
	.seo .seo-box .seo-cont .s-left .left-bottom .hz-text {
		width: 280px;
		float: left;
		margin-top: 15px;
	}
	
	/* 中间 */
	.seo .seo-box .seo-cont .s-center {
		width: 380px;
		float: left;
		height: 380px;
		background: url(../assets/img/xuebibj.png) -78px -1097px;
	}
	
	/* 右边 */
	.seo .seo-box .seo-cont .s-right {
		width: 33%;
		height: 400px;
		float: left;
	}
	
	.seo .seo-box .seo-cont .s-right .right-top {
		overflow: hidden;
		padding-bottom: 106px;
	}
	
	.seo .seo-box .seo-cont .s-right .right-top .hz-img {
		width: 110px;
		height: 110px;
		float: left;
		background: url(../assets/img/xuebibj.png) -300px -927px;
	}
	
	.seo .seo-box .seo-cont .s-right .right-top .hz-text {
		width: 280px;
		float: left;
		margin-top: 10px;
	}
	
	/* dixia */
	.seo .seo-box .seo-cont .s-right .right-bottom .hz-img {
		width: 110px;
		height: 110px;
		float: left;
		background: url(../assets/img/xuebibj.png) -696px -927px;
	}
	
	.seo .seo-box .seo-cont .s-right .right-bottom .hz-text {
		width: 280px;
		float: left;
		margin-top: 15px;
	}
	
	/* 底部 */
	.bot {
		width: 100%;
		background-color: #fff;
	}
	
	.bot .bot-box {
		width: 1200px;
		margin: 0 auto;
		overflow: hidden;
		padding-bottom: 50px;
	}
	
	.bot .bot-box .box-title {
		padding: 30px 0 10px 0;
		height: 130px;
		text-align: center;
	}
	
	.bot .bot-box .box-title div {
		font-size: 32px;
		color: #333;
	}
	
	.bot .bot-box .box-title p {
		font-size: 20px;
		color: #0c84fe;
	}
	
	.bot .bot-box .box-b {}
	
	.bot .bot-box .box-b .box-left {
		float: left;
		width: 50%;
		text-align: center;
	}
	
	.bot .bot-box .box-b .box-left img {
		width: 80%;
		margin: 0 auto;
		text-align: center;
	}
	
	.bot .bot-box .box-b .box-right {
		float: left;
		width: 50%;
		text-align: center;
	}
	
	.bot .bot-box .box-b .box-right img {
		width: 80%;
		margin: 0 auto;
		text-align: center;
	}
	/* .el-checkbox__input{
		display: none;
		z-index: -20;
	} */
	/* .el-checkbox{
		width: 86px !important;
		height: 36px !important;
	} */
	/* .el-checkbox-group>.is-checked{
		border: 1px solid red;
		background: url(../assets/img/xz.png) right bottom no-repeat;
		z-index: 1000;
	} */
	/* .el-checkbox_input{
		display: none;
	} */
</style>
